/* unplugin-vue-components disabled */import { render } from "./selectEditor.vue?vue&type=template&id=fe606b6e"
import script from "./selectEditor.vue?vue&type=script&lang=js"
export * from "./selectEditor.vue?vue&type=script&lang=js"

import "./selectEditor.vue?vue&type=style&index=0&id=fe606b6e&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__